site.megamenu = {
	init:function() {
		$('#mainmenu .mmLevel2').on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children > a','#mainmenu').on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', '#mainmenu').removeClass('open');
					$(this).parent().addClass('open');
				}

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		});
	},

	close:function() {
		$('body').removeClass('megamenu-open');
		$('.level1.open', '#mainmenu').removeClass('open');
	}
};

site.inits.push('site.megamenu.init()');